import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    importCsv(vuexContext, { path, file }) {
        const form = new FormData();
        form.append('file', file);

        return axios.$post(`/admin/${path}`, form);
    }
};
